import { Profile, Identity } from './types';

export const getUserIdentity = (profile: Profile | undefined): Identity | undefined => {
    const sub = profile ? profile.sub || '' : '';
    const identities = profile ? profile.identities : [];
    const userSub = sub ? sub.split('|') : [];
    const userId = userSub.length > 2 ? sub.replace(`${userSub[0]}|`,'') : userSub[1];
    return identities ? identities.find((i: Identity) => i.provider === userSub[0] && i.user_id === userId) : undefined;
};